import React from 'react'
import { t } from "i18next";
import withRouter from "./withRouter";
import { withTranslation } from "react-i18next";
import * as XLSX from 'xlsx'
import moment from 'moment'

const ReportExcelExport = ({
  title = "Report",
  data = [],
  columnsOrder = [],
  totalFields = [],
  dateRange = { start: null, end: null },
  fileNamePrefix = "report"
}) => {

  const handleExport = () => {
    if (!data || data.length === 0) return;

    // Détermine la plage de dates
    const start = dateRange.start ? moment(dateRange.start).format("DD/MM/YYYY") : "";
    const end = dateRange.end ? moment(dateRange.end).format("DD/MM/YYYY") : "";
    const titleLabel = [`${title} from ${start} to ${end}`];
    const titleRow = [titleLabel];

    // Réorganise les données selon columnsOrder
    const orderedData = data.map((item) => {
      const obj = {};
      columnsOrder.forEach((key) => {
        obj[key] = item[key];
      });
      return obj;
    });

    // Calcule les totaux
    const totalRow = columnsOrder.reduce((acc, key, idx) => {
      if (totalFields.includes(key)) {
        acc[key] = data.reduce((sum, item) => sum + (item[key] || 0), 0);
      } else if (idx === 1) {
        acc[key] = "TOTAL";
      } else {
        acc[key] = "";
      }
      return acc;
    }, {});

    const allData = [...orderedData, totalRow];

    // Crée la feuille
    const worksheet = XLSX.utils.aoa_to_sheet(titleRow);

    // Ajoute les données à partir de A2
    XLSX.utils.sheet_add_json(worksheet, allData, {
      origin: "A2",
      header: columnsOrder
    });

    // Fusionne les cellules du titre
    worksheet["!merges"] = [
      { s: { r: 0, c: 0 }, e: { r: 0, c: columnsOrder.length - 1 } }
    ];

    // Définir la largeur des colonnes
    worksheet['!cols'] = columnsOrder.map((key) => {
      if (key.toLowerCase().includes("description") || key.toLowerCase().includes("name")) {
        return { wch: 30 }; // colonnes longues
      }
      if (totalFields.includes(key)) {
        return { wch: 15 }; // colonnes numériques
      }
      return { wch: 20 }; // par défaut
    });

    // Crée le classeur
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, `${title} Report`);

    const cleanTitle = title.toLowerCase().replace(/\s+/g, "_");
    const fileName = `${fileNamePrefix}_${cleanTitle}_${moment().format("YYYYMMDD_HHmmss")}.xlsx`;

    // Télécharge le fichier
    XLSX.writeFile(workbook, fileName);
  };

  return (
    <button className="btn btn-success d-inline-flex align-items-center" onClick={handleExport}>
      <i className="fa fa-file-excel me-1" /> {t("export_excell")}
    </button>
  );
};

export default withRouter(withTranslation()(ReportExcelExport));
